'use client';
import { useEffect, useState } from 'react';

import { GridPattern } from '~/components/grid-pattern';

const getRandomPattern = () => {
  const pattern = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 4; i++) {
    pattern.push({ x: Math.floor(Math.random() * 11), y: Math.floor(Math.random() * 11), id: i });
  }
  return pattern;
};

let interval: ReturnType<typeof setTimeout>;

export function HeroPattern() {
  const [pattern, setPattern] = useState([
    { x: 4, y: 3, id: 0 },
    { x: 2, y: 1, id: 1 },
    { x: 7, y: 3, id: 2 },
    { x: 10, y: 6, id: 3 },
  ]);

  useEffect(() => {
    interval = setInterval(() => {
      setPattern(getRandomPattern());
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="absolute inset-0 -z-10 mx-0 max-w-none overflow-hidden">
      <div className="absolute left-1/2 top-0 h-[55rem] -ml-[38rem] w-[81.25rem] dark:[mask-image:linear-gradient(white,transparent)]">
        <div className="absolute inset-0 bg-gradient-to-r from-white/30 to-white/30 opacity-40 [mask-image:radial-gradient(farthest-side_at_top,white,transparent)] dark:from-zinc-900/30 dark:to-zinc-900/30 dark:opacity-100">
          <GridPattern
            width={100}
            height={100}
            x="-12"
            y="4"
            squares={pattern}
            className="absolute inset-x-0 inset-y-[-50%] h-[200%] w-full  fill-primary-400/20 stroke-black/30 mix-blend-overlay dark:fill-primary-400/20 dark:stroke-white/20"
          />
        </div>
      </div>
    </div>
  );
}
